export const filterArrayByMatchingValue = ({ array = [], value }) => {
  return array.filter((item) => item !== value);
};
